import { hasContractFeatureSelector } from 'app/selectors'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

/**
 * ContractFeaturesFlag is a component that renders children if the broker has the contractFeature
 * @example
 *  <ContractFeaturesFlag contractFeature={CONTRACT_FEATURES.CAN_CREATE_PROPERTIES}>
 *   <div>Can create properties</div>
 *  </ContractFeaturesFlag>
 *
 *  <ContractFeaturesFlag
 *   contractFeature={CONTRACT_FEATURES.CAN_CREATE_PROPERTIES}
 *   defaultChildren={<div>Can't create properties</div>}
 *  >
 *   <div>Can create properties</div>
 *  </ContractFeaturesFlag>
 */

function ContractFeaturesFlag({
  contractFeature,
  children = null,
  defaultChildren = null,
}) {
  const hasContractFeature = useSelector(state =>
    hasContractFeatureSelector(state, contractFeature),
  )

  if (hasContractFeature) {
    return children
  }

  return defaultChildren
}

ContractFeaturesFlag.propTypes = {
  /**
   * It comes from 'app/constants/contractFeatures'
   */
  contractFeature: PropTypes.string.isRequired,

  /**
   * defaultChildren is rendered when contractFeature is not present
   * or broker does not have the feature
   */
  defaultChildren: PropTypes.node,

  /**
   * children is rendered when contractFeature is present
   * and broker has the feature
   */
  children: PropTypes.node,
}

export default ContractFeaturesFlag
